module.exports = __webpack_public_path__ + "img/service.44dea94f.png";